let cartList = document.getElementById('cart-list');
let drawerQuantity = document.getElementById('drawer-quantity');
let drawerQuantityMobile = document.getElementById('drawer-quantity-mobile');
let nonEmpty = document.getElementsByClassName('non-empty');

let cart;

function addEventListeners() {
  let removeButtons = document.getElementsByClassName('remove-item');
  let addButtons = document.getElementsByClassName('add-button');
  let subtractButtons = document.getElementsByClassName('subtract-button');
  let quantityInputs = document.getElementsByClassName('quantity-p');
  // document.getElementById('shipping-option').addEventListener("click", function() {
  //   document.getElementById('shipping-option').dataset.selected = 'true'
  //   document.getElementById('shipping-option').classList.add("selected-shipping")
  //   document.getElementById('pickup-option').dataset.selected = 'false'
  //   document.getElementById('pickup-option').classList.remove("selected-shipping")
  //   document.getElementById('delivery-error').style.display = 'none'
  // })
  // document.getElementById('pickup-option').addEventListener("click", function() {
  //   document.getElementById('pickup-option').dataset.selected = 'true'
  //   document.getElementById('pickup-option').classList.add("selected-shipping")
  //   document.getElementById('shipping-option').dataset.selected = 'false'
  //   document.getElementById('shipping-option').classList.remove("selected-shipping")
  //   document.getElementById('delivery-error').style.display = 'none'
  // })
  for (let i = 0; i < removeButtons.length; i++) {
    removeButtons[i].addEventListener("click", function() {
      changeQuantity((i + 1), 0)
    });
  }

  for (let i = 0; i < addButtons.length; i++) {
    addButtons[i].addEventListener("click", function() {
      let newQuantity =  parseInt(quantityInputs[i].value)+ 1
      changeQuantity((i + 1), newQuantity)
    });
  }

  for (let i = 0; i < subtractButtons.length; i++) {
    subtractButtons[i].addEventListener("click", function() {
      let newQuantity =  parseInt(quantityInputs[i].value)- 1
      changeQuantity((i + 1), newQuantity)

    });
  }
  
}

document.getElementById('proceed-to-checkout').addEventListener('click', async function(event) {
  const proceedButton = event.currentTarget;

  // Check if data-recommendation attribute is set to "true"
  if (proceedButton.dataset.recommendation === "true") {
    const recommendedSection = document.getElementById('recommended-products');
    const drawerMessage = document.getElementById('draw-message');
    const productContainer = document.getElementById('prod-container');
    const drawerTotal = document.getElementById('drawer-total');
    drawerTotal.innerHTML = ">";

    const recommendedDrawerAdd = document.getElementsByClassName('recommended-drawer-add');

    // Attach async click event to each recommended product's "Add" button
    Array.from(recommendedDrawerAdd).forEach(button => {
      button.addEventListener("click", async function() {
        // Check if the button already says "✔ Added" to prevent further clicks
        if (button.textContent.includes("✔ Added")) {
          return;  // Exit the function if already added
        }

        if (button.dataset.inventory > 0) {
          const formData = {
            'items': [{
              'id': parseInt(button.dataset.id),
              'quantity': 1
            }]
          };

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            });

            if (!response.ok) throw new Error('Network response was not ok');

            const responseData = await response.json();
            console.log(responseData);

            // Update the cart UI with the new item count and total price
            document.getElementById("bag-total").innerHTML = responseData.original_total_price;
            document.getElementById("bag-total-mobile").innerHTML = responseData.original_total_price;

            const drawerQuantityElement = document.getElementById("drawer-quantity");
            let currentQuantity = parseInt(drawerQuantityElement.innerHTML, 10) || 0; // Get current quantity or default to 0 if not set
            drawerQuantityElement.innerHTML = currentQuantity + 1;
            document.getElementById("drawer-quantity-mobile").innerHTML = currentQuantity + 1;

            // Change the color of the clicked "Add" button and update text
            button.style.color = '#CD425F';
            button.style.backgroundColor = '#ffffff';
            button.innerHTML = "✔ Added";

            // Disable the button to prevent further clicks
            button.disabled = true;

          } catch (error) {
            console.error('Error:', error);
          }
        }
      });
    });

    // Show recommended products if hidden, else proceed to checkout
    if (recommendedSection.classList.contains('hidden')) {
      event.preventDefault();  // Prevent navigation on first click
      recommendedSection.classList.remove('hidden');  // Show recommended products
      drawerMessage.classList.add('hidden');
      productContainer.classList.add('hidden');
    } else {
      // Allow navigation to the checkout on the second click
      window.location.href = proceedButton.href;
    }

  } else {
    // Navigate directly to the href if data-recommendation is not "true"
    window.location.href = proceedButton.href;
  }
});


function renderLineItems (items, total, quantity) {
  let itemsArray = [`<div id="cart-continue-shopping" class="cursor-pointer border mt-12 text-center w-fit mx-auto text-xsm border-black rounded-full p-[13px] px-5">Continue shopping</div>`];
  for (let i = 0; i < items.length; i++) {
    const title = items[i].title;
    const price = '$' +(parseInt(items[i].price)/100).toFixed(2).toString();
    const image = items[i].image
    const quantity = items[i].quantity
    const id = items[i].id
    const itemTemplate = `<li class="flex mb-[20px] px-5 drawer-item">
      <div class="h-[130px] w-[130px] flex-shrink-0 overflow-hidden">
        <img
          src="${image}"
          width="180"
          height="180"
          alt="Salmon orange fabric pouch with match zipper, gray zipper pull, and adjustable hip belt."
          class="h-full object-cover object-center aspect-square w-[180px]"
        >
      </div>

      <div class="ml-4 flex flex-1 flex-col mt-[10px]">
        <div>
          <div class="flex justify-between text-xsm leading-3 text-gray-900">
            <h3>
              <a class="font-bold" href="${items[i].url}">${title}</a>
            </h3>
          </div>
          <p class="mt-4 text-xsm leading-5">${price}</p>
        </div>
        <div class="my-4 block w-fit bg-white border border-[#ececec] rounded-full"
          data-hs-input-number="">
          <div class="flex items-center">
            <button data-id="${id}" type="button" class="subtract-button size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none" tabindex="-1" aria-label="Decrease" data-hs-input-number-decrement="">
              <svg class="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#CD425F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
              </svg>
            </button>
            <input class="quantity-p leading-4 p-0 w-6 bg-transparent border-0 text-gray-800 text-center focus:ring-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none text-xsm" style="-moz-appearance: textfield;" aria-roledescription="Number field" value="${quantity}" type="number" id="quantity" name="quantity" min="1" data-hs-input-number-input="">
            <button data-id="${id}" type="button" class="add-button size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none" tabindex="-1" aria-label="Increase" data-hs-input-number-increment="">
              <svg class="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#CD425F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
                <path d="M12 5v14"></path>
              </svg>
            </button>
          </div>
        </div>
        <div class="flex flex-1 items-end justify-between text-xsm">
          <p class="remove-item text-xsm leading-3 underline cursor-pointer">Remove</p>
        </div>
      </div>
    </li>`
    itemsArray[i] = itemTemplate
  }
  cartList.innerHTML = itemsArray.join('')
  document.getElementById("bag-total").innerHTML = quantity;
  document.getElementById("bag-total-mobile").innerHTML = quantity;
  document.getElementById("drawer-total").innerText = `$${(parseInt(total) / 100).toFixed(2)}`;

  drawerQuantityMobile.innerHTML = quantity;
  drawerQuantity.innerHTML = quantity;
  if (quantity < 1) {
      document.getElementById('cart-continue-shopping').addEventListener('click', function () {
      document.getElementById('translate-cart').style.transform = 'translateX(100%)';
      document.getElementById('cart-menu').style.visibility = 'hidden';
      document.getElementById('opacity').style.opacity = 0;
    });
    for (let i = 0; i < nonEmpty.length; i++) {
      nonEmpty[i].classList.add("!hidden");
    }
  } else {
    for (let i = 0; i < nonEmpty.length; i++) {
      nonEmpty[i].classList.remove("!hidden");
    }
  }
  addEventListeners()
}

async function getCart() {
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const responseData = await response.json();
    renderLineItems(responseData.items, responseData.original_total_price, responseData.item_count);
    return cart = responseData;
  } catch (error) {
    console.error('Error:', error);
  }
}


function addToCart(id, quantity) {
  let formData = {
    'items': [{
      'id': id,
      'quantity': quantity
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      let responseData = response.json()
      getCart()
      document.getElementById('cart-menu').style.visibility = 'visible';
      document.getElementById('opacity').style.opacity = 0.75;
      document.getElementById('translate-cart').style.transform = 'translateX(0)';
      return responseData;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function changeQuantity(line, quantity) {
  let formData = {
    'line': line,
    'quantity': quantity
  }  

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      let responseData = response.json()
      getCart()
      return responseData;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
